<!-- <div class="web-view videocontainer">
    <div  fxLayout="column">
        <span class="span1"><a (click)="backClicked()"><img src="assets\images\cinejoy\arrow-left.png"></a></span>
        <div class="main-div">
            <ng-container *ngIf="canUserAccessMovie">
                <iframe class="iframeVideo" id="iframeid1" [src]="streamLink" allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen">
                </iframe>
              
            </ng-container>
            <div class="Main-Section" fxLayout="column" fxLayoutAlign="center center"  *ngIf="!canUserAccessMovie">
                <span class="web-error-message">{{message}}</span>
            </div>
        </div>
    </div>
</div> -->

<div class="mobile-view">
    <div class="videocontainer" fxLayout="column">
        <span class="span1"><a (click)="backClicked()" ><img src="assets\images\cinejoy\arrow-left.png"></a></span>
        <div class="main-div">
            <ng-container *ngIf="canUserAccessMovie">
             <iframe class="iframeVideo" id="iframeid1" [src]="streamLink" allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen">
                </iframe>
               
            </ng-container>
            <div class="Main-Section" fxLayout="column" fxLayoutAlign="center center">
                <span class="web-error-message" *ngIf="!canUserAccessMovie" [innerHTML]="message"></span>
            </div>
        </div>
    </div>
</div>